








































import Vue from "vue";
import { store } from "../services/store";
import { cutImage } from "@/utils/img";
import { openScheme } from "@/utils/openUrl";

let vm = null;

export default Vue.extend({
  data() {
    return {
      clueSwiperOption: {
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        loop: true,
        autoplay: true
      },
      swiperOption: {
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination", // 设置类名，可以修改样式
          clickable: true,
          bulletClass: "clue-bullet",
          bulletActiveClass: "clue-bullet-active"
        },
        on: {
          click: function() {
            // @ts-ignore
            const realIndex = this.realIndex;
            // @ts-ignore
            vm.handleClick(realIndex);
          }
        }
      },
      clues: [
        "https://activity.hdslb.com/blackboard/static/zifFpXrDZe.jpg",
        "https://activity.hdslb.com/blackboard/static/9YbE8mKPvr.jpg",
        "https://activity.hdslb.com/blackboard/static/4HiXtkcuxK.jpg",
        "https://activity.hdslb.com/blackboard/static/9bJCqXtqr0.jpg",
        "https://activity.hdslb.com/blackboard/static/d2zLKM8wCT.jpg",
        "https://activity.hdslb.com/blackboard/static/WkDdr2QK3A.jpg",
        "https://activity.hdslb.com/blackboard/static/e95g8ZraMa.jpg"
      ],
      banners: [
        {
          img: "https://activity.hdslb.com/blackboard/static/TvmX3QUpnz.png",
          link: "https://www.bilibili.com/blackboard/2023GameSFG-ZP.html?navhide=1"
        },
        {
          img: "https://activity.hdslb.com/blackboard/static/F5mD19nqB3.png",
          link: "https://www.bilibili.com/h5/mall/home?navhide=1"
        },
        {
          img: "https://activity.hdslb.com/blackboard/static/5zPP0m2Mbb.png",
          link: "https://game.bilibili.com/gameroom/2023happyNY/h5?navhide=1"
        },
        {
          img: "https://activity.hdslb.com/blackboard/static/ak0V1gyoj9.png",
          link: "https://m.bilibili.com/doria/new-year-2023.html?navhide=1&msource=zhuotutu"
        }
      ]
    };
  },
  computed: {
    clueImg() {
      return store.clueBanner;
    }
  },
  created() {
    // @ts-ignore
    vm = this;
  },
  methods: {
    jump(link: string) {
      if (link) {
        openScheme(link);
      }
    },
    cutImage(url: string, width: number): string {
      return cutImage(url, width);
    },
    handleClick(index: number) {
      const link = this.banners[index].link;
      this.jump(link);
    }
  }
});
